import classnames from 'classnames'
import Image from 'next/image'
import React, { PropsWithChildren } from 'react'
import classes from './bigImageBanner.module.scss'


export type BigImageProps = {
  imageUrl: string
  imagePosition: 'left' | 'right' | 'center'
}

export const BigImageBanner:React.FC<PropsWithChildren<BigImageProps>> = ({ imageUrl, imagePosition })=> {
  return (
    <div className={classnames(classes.bigImageWrapper, [classes[`${imagePosition}`]])}>
      <div className={classnames(classes.bigImageMask)}  >
        <Image
          src={`${imageUrl}`}
          width={1485}
          height={1026}
        />
      </div>
    </div>
  )
}

export default BigImageBanner
